var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00502 14.4949L4.22433 10.7142H17.5001C17.8946 10.7141 18.2144 10.3943 18.2144 9.99988C18.2144 9.60543 17.8946 9.28565 17.5001 9.28559H4.22433L8.00502 5.5049C8.28397 5.22595 8.28397 4.7738 8.00502 4.49485C7.72607 4.21591 7.27392 4.21591 6.99498 4.49485L1.99498 9.49485C1.71603 9.7738 1.71603 10.226 1.99498 10.5049L6.99498 15.5049C7.27392 15.7838 7.72607 15.7838 8.00502 15.5049C8.28397 15.226 8.28397 14.7738 8.00502 14.4949Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.87fc0b5cd3bc5bff174a17e89e851da1.svg";
export { ForwardRef as ReactComponent };